// src/components/AboutUs/AboutUs.js
import React, { useState } from 'react';
import './AboutUs.css';

import Timeline from '../Timeline/Timeline';
import InfoCards from '../InfoCards/InfoCards';

import AboutUsImage from '../Assets/OtherImages/AboutUs.jpg';
import WhyWeExistImage from '../Assets/OtherImages/whyweexist.jpg';
import OurImpactImage from '../Assets/OtherImages/ourimpact.jpg';
import SafeTalkIcon from '../Assets/OtherImages/safetalk.png';
import WorkshopsIcon from '../Assets/OtherImages/workshops.jpg';
import RespondersIcon from '../Assets/OtherImages/responders.jpg';
import ParallaxImageBand from '../ParallaxImageBand/ParallaxImageBand';
import QuoteBanner from '../QuoteBanner/QuoteBanner';

const panels = [
  {
    title: 'About Us',
    image: AboutUsImage,
    description:
      "Man of Valor is a South African non-profit born from brotherhood and built on purpose. Founded in 2023 by a group of men from Johannesburg, our mission is clear: to shatter the silence surrounding men's mental health.",
  },
  {
    title: 'Why We Exist',
    image: WhyWeExistImage,
    description:
      "Too many men carry their pain alone, held back by stigma and the pressure to stay silent. Man of Valor is here to change that by turning vulnerability into strength and building a brotherhood where no man walks through darkness by himself.",
  },
  {
    title: 'Our Impact',
    image: OurImpactImage,
    description:
      'We’ve already hit the ground running—literally. With two awareness runs from Johannesburg to Durban and dedicated mental fitness bootcamps, we’ve sparked crucial conversations, connected with over 450,000 people through our channels, and made mental health a topic men can finally talk about. But awareness is just the start.',
  },
];

const timelineEvents = [
  { year: '2023', text: 'Founded by a group of men from Johannesburg South' },
  { year: '2024', text: 'First awareness run: Johannesburg → Durban' },
  { year: '2025', text: '300,000+ reached via social media & radio' },
];

const buildingCards = [
  {
    icon: SafeTalkIcon,
    title: 'Partnering with Safe Talk',
    description: 'Provide direct access to professional help.',
  },
  {
    icon: WorkshopsIcon,
    title: 'Community Workshops',
    description:
      'Teach men how to identify & manage mental health challenges.',
  },
  {
    icon: RespondersIcon,
    title: 'Training First Responders',
    description: 'Equip local leaders to offer immediate support.',
  },
];

const AboutUs = () => {
  // Mobile slider active panel index
  const [activeIndex, setActiveIndex] = useState(0);

  const goNext = () => {
    setActiveIndex((prev) => (prev + 1) % panels.length);
  };

  const goPrev = () => {
    setActiveIndex((prev) => (prev - 1 + panels.length) % panels.length);
  };

  return (
    <section id="about" className="about-us">
      {/* DESKTOP: angled hover panels */}
      <div className="panels-desktop">
        {panels.map((p, i) => {
          const pos = i === 0 ? 'left' : i === 1 ? 'center' : 'right';
          return (
            <div
              key={p.title}
              className={`panel ${pos}`}
              style={{ backgroundImage: `url(${p.image})` }}
            >
              <div className="info">
                <h2>{p.title}</h2>
                <div className="info-backdrop">
                  <p>{p.description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* MOBILE: interactive slider */}
      <div className="panels-mobile">
        {/* Tabs (titles) */}
        <div
          className="panels-mobile__tabs"
          role="tablist"
          aria-label="About Man of Valor"
        >
          {panels.map((p, i) => (
            <button
              key={p.title}
              type="button"
              role="tab"
              className={`panels-mobile__tab ${
                i === activeIndex ? 'is-active' : ''
              }`}
              aria-selected={i === activeIndex}
              onClick={() => setActiveIndex(i)}
            >
              {p.title}
            </button>
          ))}
        </div>

        {/* Slider viewport */}
        <div className="panels-mobile__viewport">
          {panels.map((p, i) => (
            <article
              key={p.title}
              className={`panels-mobile__slide ${
                i === activeIndex ? 'is-active' : ''
              }`}
              style={{ backgroundImage: `url(${p.image})` }}
            >
              <div className="panels-mobile__overlay">
                <h2>{p.title}</h2>
                <p>{p.description}</p>
              </div>
            </article>
          ))}

          <button
            type="button"
            className="panels-mobile__arrow panels-mobile__arrow--prev"
            onClick={goPrev}
            aria-label="Previous"
          >
            ‹
          </button>
          <button
            type="button"
            className="panels-mobile__arrow panels-mobile__arrow--next"
            onClick={goNext}
            aria-label="Next"
          >
            ›
          </button>
        </div>

        {/* Dots */}
        <div className="panels-mobile__dots">
          {panels.map((p, i) => (
            <button
              key={p.title}
              type="button"
              className={`panels-mobile__dot ${
                i === activeIndex ? 'is-active' : ''
              }`}
              onClick={() => setActiveIndex(i)}
              aria-label={`Go to ${p.title}`}
            />
          ))}
        </div>
      </div>

      {/* TIMELINE + extras */}
      <QuoteBanner />
      <ParallaxImageBand text="RUN WITH PURPOSE" />
      {/* <InfoCards cards={buildingCards} /> */}
    </section>
  );
};

export default AboutUs;
